export enum SourceType {
    Check,
    EMELIE,
    SME
}